import React from "react";
import { Button, InfoAlert, Card } from "../../shared/components";
import { useAppSelector, useThunkDispatch } from "../../store/index";
import { closeWsConnection, openWsConnection, sendCurrentTemplateToVsCode } from "../../store/vscode/actions";
import { useJsxParserComponents } from "../../shared/providers/JsxParserComponentsProvider";

function VsCode() {
    const state = useAppSelector(state => state.vsCode);
    const dispatch = useThunkDispatch();
    const components = useJsxParserComponents();

    return (
        <div className='table-container'>
            <Card className="vscode-layout plush">
                <InfoAlert>
                    In order to utilize this functionality, please ensure that the <a href="https://marketplace.visualstudio.com/items?itemName=qerent.sc-canvas-toolkit" target="_blank" rel="noreferrer">VS Code Extension</a> is installed and running locally.
                </InfoAlert>

                <span className="connection-status">
                    <span className="label">Connection Status : </span>
                    <span className="value">{state.connectionStatus}</span>
                </span>

                <Button variant="outlined" color="primary" onClick={() => state.connectionStatus === "OPEN" ? dispatch(closeWsConnection()) : dispatch(openWsConnection(components))}>{state.connectionStatus === "OPEN" ? "Disconnect" : "Connect"}</Button>
                <Button variant="outlined" color="secondary" onClick={() => dispatch(sendCurrentTemplateToVsCode())}>Send Template to VS Code</Button>
            </Card>
        </div>
    );
}

export default VsCode;
